/* import __COLOCATED_TEMPLATE__ from './native-status.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ProjectVersionsNativeStatusComponent extends Component {
  @service platform;
}
